import React from 'react';
import Button from '@mui/material/Button';

const CenterImage: React.FunctionComponent = () => {
  return (
    <Button sx={{ borderRadius: 8, mt: 2, mb: 2 }} variant="contained">
      Select Center Image
    </Button>
  );
};

export default CenterImage;
